const getInitialvalues = (filters) => {
  return {
    user_id: filters.user_id || [],
    created_at_from: filters.created_at_from || null,
    created_at_to: filters.created_at_to || null,
    related_to: filters.related_to || "",
  };
};

export default getInitialvalues;
